/* eslint-disable max-len */
import {
  useMemo,
  useState,
  useEffect,
  SetStateAction,
  useContext,
} from "react";
import { useScreenClass } from "react-grid-system";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { FlexGrow } from "../../components/FlexBox";
import { NullStateText } from "../../components/Text";
import theme from "../../styles/theme";
import axios from "axios";
import {
  EmptyPillarNavigation,
  EmptyPillarTypeDetail,
  PillarNavigationType,
  PillarTypeDetail,
} from "../../types/Roadmap";
import PillarOverviewModify from "../../components/PillarOverviewModify";
import PillarNavigator from "../../components/PillarNavigator";
import { CustomFlex } from "./ModifyPillarDetail";
import PillarSubdomainModify from "../../components/PillarSubdomainModify";
import KnowledgeAreaModify from "../../components/KnowledgeAreaModify";
import SnackBar from "../../components/SnackBar";
import LoadingSpinner from "../../components/LoadingSpinner";
import { VersionContext } from "../../context/VersionContext";
interface CourseColumn {
  id: "title" | "number" | "pillar" | "competencies";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}
const courseColumns: readonly CourseColumn[] = [
  { id: "title", label: "Course Title", minWidth: 200 },
  {
    id: "number",
    label: "Course Number",
    minWidth: 150,
  },
  { id: "pillar", label: "Pillar", minWidth: 80 },

  {
    id: "competencies",
    label: "Competencies",
    minWidth: 250,
  },
];
function ModifyKnowledgeAreaDetail(this: any) {
  const navigate = useNavigate();
  const { pillarId, subdomainId, knowledgeId } = useParams();
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const [knowledgeAreaDetail, setKNowledgeAreaDetail] = useState<{
    id: string;
    description: string;
    title: string;
  }>({ id: "", description: "", title: "" });
  const [pillarNavigation, setPillarNavigation] =
    useState<PillarNavigationType>(EmptyPillarNavigation);
  const [loading, setLoading] = useState<boolean>(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [knowledgeAreas, setKnowledgeAreas] = useState<Array<any>>([]);

  useEffect(() => {
    if (pillarId && subdomainId && knowledgeId) {
      // fetchSubdomain(pillarId, subdomainId, knowledgeId)
      fetchKnowledgeArea(pillarId, subdomainId, knowledgeId);
    }
  }, []);
  const { version } = useContext(VersionContext);

  const fetchKnowledgeArea = (
    pillar_id: string,
    subdomain_id: string,
    knowledgeId: string
  ) => {
    axios
      .get(`/knowledgearea?subdomain_id=${subdomain_id}&area_id=${knowledgeId}`)
      .then((res) => {
        axios
          .get(`/pillar?curriculum_version=${version.version_number}`)
          .then((res1) => {
            axios
              .get(`/subdomain/summary?pillar_id=${pillarId}&curriculum_version=${version.version_number}`)
              .then((res2) => {
                setKNowledgeAreaDetail(res.data.knowledgeareas[0]);
                setPillarNavigation({
                  ...pillarNavigation,
                  title: res1.data.pillars.find((v: any) => v.id === pillarId)
                    .title,
                  id: pillar_id,
                  subdomains: {
                    ...pillarNavigation.subdomains,
                    title: res2.data.subdomains.find(
                      (v: any) => v.id === subdomainId
                    ).title,
                    id: subdomain_id,
                    knowledge_areas: {
                      ...pillarNavigation.subdomains.knowledge_areas,
                      id: knowledgeId,
                      title: res.data.knowledgeareas[0].title,
                    },
                  },
                });
              })
              .catch(() => {});
          })
          .catch(() => {});
      })
      .catch(() => {});
  };
  // const fetchSubdomain = (pillar_id: string, subdomain_id: string, knowledge_id: string) => {
  //   setLoading(true);
  //   axios
  //     .get('/subdomain')
  //     .then((res) => {
  //       filterData(res.data.pillars, pillar_id, subdomain_id, knowledge_id);
  //     })
  //     .catch(() => { });
  // };
  // const filterData = (data: any, id: string, subdomainID: string, knowledgeID: string) => {
  //   data.forEach((element: PillarTypeDetail, index: any) => {
  //     if (element.id === id) {
  //       element.subdomains.forEach((subdomain: any) => {
  //         if (subdomain.id === subdomainID) {
  //           subdomain.knowledge_areas.forEach((knowledge: { id: string; description: string; title: string; }) => {
  //             if (knowledge.id === knowledgeID) {
  //               setKNowledgeAreaDetail(knowledge)
  //               setPillarNavigation({
  //                 ...pillarNavigation,
  //                 code: element.code,
  //                 description: element.description,
  //                 graphics: element.graphics,
  //                 id: element.id,
  //                 is_core: element.is_core,
  //                 title: element.title,
  //                 subdomains: {
  //                   ...pillarNavigation.subdomains,
  //                   id: subdomain.id,
  //                   description: subdomain.description,
  //                   title: subdomain.title,
  //                   knowledge_areas: {
  //                     ...pillarNavigation.subdomains.knowledge_areas,
  //                     id: knowledge.id,
  //                     description: knowledge.description,
  //                     title: knowledge.title
  //                   }
  //                 }
  //               })
  //             }
  //           });
  //         }
  //       })
  //     }
  //     setLoading(false);
  //   })
  // }
  const updateKnowledgeData = (data: any) => {
    setLoading(true);
    axios
      .put("/knowledgearea/update", { ...data, id: knowledgeId })
      .then((res) => {
        setMessage("Updated knowledge area successfully");
        setIsSnackbarOpen(true);
        fetchKnowledgeArea(
          pillarId || "",
          subdomainId || "",
          knowledgeId || ""
        );
        setLoading(false);
      })
      .catch(function (error) {
        if (error.response) {
          setMessage(
            error.response.data.error || "Failed to update knowledge area!"
          );
          setIsErrorOpen(true);
        } else if (error.request) {
          console.log(error.request);
        } else {
          setMessage(error.response.data.error);
          setIsErrorOpen(true);
        }
        setLoading(false);
      });
  };
  return (
    <>
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message}
        type="error"
      />
      {knowledgeAreaDetail && knowledgeAreaDetail.id !== "" ? (
        <CustomFlex
          style={{
            minHeight: "inherit",
            height: "100%",
            borderBottom: "none",
            alignItems: "flex-start",
            overflowY: "scroll",
            padding: 0,
          }}
        >
          <FlexGrow
            className="visible-scrollbar"
            style={{
              overflowX: "auto",
              maxHeight: "calc(100vh - 90px)",
              minHeight: "calc(100vh - 90px)",
            }}
          >
            <CustomFlex>
              <FlexGrow>
                <PillarNavigator path={pillarNavigation} />
              </FlexGrow>
            </CustomFlex>
            {loading && <LoadingSpinner />}
            <KnowledgeAreaModify
              knowledgeData={knowledgeAreaDetail}
              goBack={() => {}}
              onSaveComplete={(data) => {
                updateKnowledgeData(data);
              }}
            />
          </FlexGrow>
        </CustomFlex>
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
}
export default ModifyKnowledgeAreaDetail;
